import React, { Component } from 'react';

import { Checkbox } from 'antd';
import { Formik, Form } from 'formik';
import _findIndex from 'lodash/findIndex';
import { DateTime } from 'luxon';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import InputBlock from 'containers/InputBlock';
import Heading from 'containers/MainHeading';
import SelectOption from 'containers/SelectOption';

import BottomStickyButton from 'components/ShortCuts/BottomStickButton';
import AccountDropdown from 'components/User/AccountDropdown';

import * as SellerAPI from 'services/SellerApi';
import Storage from 'services/storage';

import OptionsUtils from 'util/OptionsUtils';
import classNames from 'util/classNames';
import { formatInlineList, isArray, isEmpty, isObject, isString } from 'util/utils';

import { KYC_STATUS } from 'constants/Common';

class ClientKYCDetail extends Component {
  static propTypes = {
    account: PropTypes.any,
    createAccount: PropTypes.func,
    updateAccount: PropTypes.func,
  };

  state = {
    groups: [],
    sellers: [],
    cities: [],
    states: [],
    countries: [],
    loading: true,
    saveContinue: false,
  };

  masters = undefined;
  broker = undefined;
  groups = [];
  kycStatus = [];

  componentDidMount() {
    this.handleMount();
    this.getKycMaster();
  }

  getKycMaster = () => {
    this.masters = Storage.get('master');
    this.groups = this.masters?.COMPANY_GROUP?.map((item) => ({
      ...item,
      id: item.id[0],
    }));
  };

  handleMount = async () => {
    await Promise.all([this.getSalesPerson(), this.initCountryStateCity()]);
    this.setState({ loading: false });
  };

  initCountryStateCity = async () => {
    await this.getCountries();

    const countryId = this.props?.account?.country?.id;
    if (!isEmpty(countryId)) this.getStates(countryId);

    const stateId = this.props?.account?.state?.id;
    if (!isEmpty(stateId)) this.getCities(stateId);
  };

  getSalesPerson = async () => {
    const [err, res] = await SellerAPI.getSellerList();
    const success = !err && res?.code === 'OK';

    if (success && isArray(res.data)) {
      this.setState({
        sellers: res.data.map(({ id, firstName, lastName }) => ({
          id,
          name: `${firstName}${lastName !== '_' ? ' ' + lastName : ''}`,
        })),
      });
    }
  };

  getCountries = async () => {
    const countries = await OptionsUtils.getCountryOptions();
    this.setState({ countries });
  };

  getStates = async (country) => {
    this.setState({ states: [] });
    const states = await OptionsUtils.getStateOptions(country);
    this.setState({ states });
  };

  getCities = async (state) => {
    this.setState({ cities: [] });
    const cities = await OptionsUtils.getCityOptions(state);
    this.setState({ cities });
  };

  submitForm = async (values, { setSubmitting, resetForm }) => {
    const { account } = this.props;

    const groups = account?.group || [];
    const groupIndex = _findIndex(groups, { isActive: true });
    const groupId = groupIndex > -1 ? groups[groupIndex].id : '';

    let group = [];
    if (values?.group && values?.group != groupId) {
      group = (!isString(account?.group) && !isEmpty(account?.group) ? account?.group : [])?.map((item) => ({
        ...item,
        isActive: false,
      }));
      group.push({ id: values?.group, time: DateTime.local(), isActive: true });
    } else {
      group = groups;
    }

    if (account.isApproved != Number(values?.isApproved) && !isEmpty(account?.kyc)) {
      values.kyc = account.kyc.map((item) => {
        item.status = Number(values?.isApproved);
        return item;
      });
    }

    values.approveStatusChanged = account.isApproved !== values.isApproved;

    values.isApproved = Number(values.isApproved);
    values.seller = values.seller || null;

    // if (!isArray(values.mobiles)) values.mobiles = values.mobiles?.split(',').map((item) => item.trim());
    if (!isArray(values.emails)) values.emails = values.emails?.split(',').map((item) => item.trim());
    if (!isArray(values.faxes)) values.faxes = values.faxes?.split(',').map((item) => item.trim());
    values.broker = isObject(values.broker) ? values?.broker?.id : values.broker;

    setSubmitting(true);
    const [err, res] = await (isEmpty(account?.id)
      ? this.props.createAccount({ ...values, group, isVerified: values.isVerified ? 2 : 1 })
      : this.props.updateAccount(account?.id, { ...values, group, isVerified: values.isVerified ? 2 : 1 }));
    setSubmitting(false);

    if (!err && res?.code === 'OK') {
      if (this.state.saveContinue) {
        this.props.updateSubTabIndex();
      } else {
        resetForm();
        this.props.onCancel();
      }
    }
  };

  initialValues = {
    country: undefined,
    state: undefined,
    city: undefined,
    companyName: '',
    vendorCode: '',
    address: '',
    emails: '',
    zipCode: '',
    isActive: true,
    isVerified: true,
    showNatural: true,
    showLabGrown: false,
    isApproved: 2,
    seller: null,
    group: undefined,
    broker: undefined,
    name: '',
    // email: '',
    Website: '',
    mobiles: '',
    faxes: '',
    contactEmail: '',
    contactMobile: '',
    vendorLogo: '',
  };

  getInitialValues = () => {
    const account = { ...this.props.account };

    this.broker = undefined;

    account.isVerified = account.isVerified === 2 || isEmpty(this.props.account) ? true : false;

    const groups = account?.group || [];
    const groupIndex = _findIndex(groups, { isActive: true });
    account.group = groupIndex > -1 ? groups[groupIndex].id : '';

    // assign Ids to prepopulated fields
    const populatedFieldNames = ['country', 'state', 'city', 'seller'];
    populatedFieldNames.forEach((fieldName) => (account[fieldName] = account?.[fieldName]?.id));

    return Object.fromEntries(
      Object.entries(this.initialValues).map(([key, value]) => [key, isEmpty(account?.[key]) ? value : account?.[key]]),
    );
  };

  componentDidUpdate(prevProps) {
    if (prevProps.account.id !== this.props.account.id) {
      this.handleMount();
      this.getKycMaster();
    }
  }

  validationSchema = () =>
    Yup.object().shape({
      companyName: Yup.string().trim().required('Please enter company name'),
      vendorCode: Yup.string().trim(),
      address: Yup.string().trim(),
      emails: Yup.string().required('Please enter emails'),
      mobiles: Yup.array()
        .of(Yup.string().matches(/^[0-9]{7,15}$/, 'Phone number length should between 7-15 and contains only number'))
        .required('Please enter phone no'),
      country: Yup.string().trim(),
      state: Yup.string().trim(),
      city: Yup.string().trim(),
      zipCode: Yup.string().trim(),
      isActive: Yup.boolean(),
      isVerified: Yup.boolean(),
      showNatural: Yup.boolean(),
      showLabGrown: Yup.boolean(),
      isFm: Yup.boolean(),
      // seller: Yup.string(),
      group: Yup.string(),
      name: Yup.string(),
      contactEmail: Yup.string().email('Please enter valid email'),
      contactMobile: Yup.string()
        .trim()
        .matches(/^[0-9]{7,15}$/, 'Mobile number length should between 7-15 and contains only number'),
      Website: Yup.string().url('Invalid URL'),
      faxes: Yup.string().trim(),
      // vendorLogo: Yup.string().trim().required('Please choose logo'),
    });

  render() {
    const { cities, states, countries, sellers } = this.state;

    return (
      <Formik
        enableReinitialize
        initialValues={this.getInitialValues()}
        validationSchema={this.validationSchema}
        validateOnChange
        onSubmit={this.submitForm}
      >
        {({
          handleChange,
          handleBlur,
          setFieldValue,
          setFieldTouched,
          submitForm,
          setValues,
          touched,
          errors,
          values,
        }) => (
          <Form>
            <div className={classNames(['kycFormMainBlock'])}>
              <div className="kycBlockWrapper mb-20">
                <InputBlock
                  name="companyName"
                  label="Company Name *"
                  placeholder="Company Name"
                  type="text"
                  value={values?.companyName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched?.companyName && errors?.companyName}
                />
                <InputBlock
                  name="vendorCode"
                  label="Company Code"
                  placeholder="Company Code"
                  type="text"
                  value={values?.vendorCode}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched?.vendorCode && errors?.vendorCode}
                />
                <InputBlock
                  name="address"
                  label="Address"
                  placeholder="Address"
                  type="text"
                  value={values?.address}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched?.address && errors?.address}
                />
                <InputBlock
                  name="emails"
                  label="Email *"
                  placeholder="Email"
                  type="text"
                  value={values?.emails}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched?.emails && errors?.emails}
                />
                <InputBlock
                  name="mobiles"
                  label="Phone no. *"
                  placeholder="Phone no."
                  type="text"
                  onKeyPress={(evt) => {
                    if ((evt.which < 48 || evt.which > 57) && evt.which !== 44) {
                      evt.preventDefault();
                    }
                  }}
                  value={values?.mobiles}
                  onChange={(event) => {
                    const value = event.target.value
                      ?.split(',')
                      ?.map((item) => item.replace(/\D/g, ''))
                      ?.join(',');

                    if (isString(value))
                      setValues((values) => ({
                        ...values,
                        mobiles: formatInlineList(value, { allowAppend: true }).split(','),
                      }));
                  }}
                  onBlur={handleBlur}
                  error={touched?.mobiles && errors?.mobiles}
                />
                <InputBlock
                  name="zipCode"
                  label="Zip/Pin Code"
                  placeholder="Zip/Pin Code"
                  type="text"
                  onKeyPress={(evt) => {
                    if (evt.which < 48 || evt.which > 57) {
                      evt.preventDefault();
                    }
                  }}
                  value={values?.zipCode}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched?.zipCode && errors?.zipCode}
                />
                <SelectOption
                  value={countries?.filter((item) => item.key == values?.country).length ? values?.country : undefined}
                  onChange={(value) => {
                    this.getStates(value);
                    setFieldValue('city', undefined);
                    setFieldValue('state', undefined);
                    setFieldValue('country', value);
                  }}
                  onBlur={() => setFieldTouched('country', true)}
                  name="country"
                  error={touched?.country && errors?.country}
                  label="Country"
                  placeholder="Select Country"
                  selectValue={countries}
                  showSearch
                />
                <SelectOption
                  value={states?.filter((item) => item.key == values?.state).length ? values?.state : undefined}
                  onChange={(value) => {
                    this.getCities(value);
                    setFieldValue('state', value);
                    setFieldValue('city', undefined);
                  }}
                  onBlur={() => setFieldTouched('state', true)}
                  name="state"
                  error={touched?.state && errors?.state}
                  label="State"
                  placeholder="Select State"
                  selectValue={states}
                  showSearch
                />
                <SelectOption
                  value={cities?.filter((item) => item.key == values?.city).length ? values?.city : undefined}
                  onChange={(value) => setFieldValue('city', value)}
                  onBlur={() => setFieldTouched('city', true)}
                  name="city"
                  error={touched?.city && errors?.city}
                  label="City"
                  placeholder="Select City"
                  selectValue={cities}
                  showSearch
                />
                <SelectOption
                  value={sellers?.filter((item) => item.id == values?.seller).length ? values?.seller : null}
                  onChange={(value) => setFieldValue('seller', value)}
                  onBlur={() => setFieldTouched('seller', true)}
                  name="seller"
                  error={touched?.seller && errors?.seller}
                  label="Sales Person"
                  placeholder="Select Sales Person"
                  selectValue={sellers}
                  nameKey="name"
                  valueKey="id"
                  showSearch
                />
                <SelectOption
                  value={this.groups?.filter((item) => item.id == values?.group).length ? values?.group : undefined}
                  onChange={(value) => setFieldValue('group', value)}
                  onBlur={() => setFieldTouched('group', true)}
                  name="group"
                  error={touched?.group && errors?.group}
                  label="Group"
                  placeholder="Select Group"
                  selectValue={this.groups}
                  nameKey="name"
                  valueKey="id"
                  showSearch
                />
                <AccountDropdown
                  initialValue={values?.broker}
                  value={values?.broker}
                  label="Broker"
                  name="broker"
                  onChange={(broker) => {
                    setFieldValue('broker', broker);
                  }}
                  ledgerType="broker"
                />
                <SelectOption
                  value={
                    KYC_STATUS?.filter((item) => item.key == values?.isApproved).length
                      ? `${values?.isApproved}`
                      : undefined
                  }
                  onChange={(value) => setFieldValue('isApproved', value)}
                  onBlur={() => setFieldTouched('isApproved', true)}
                  name="isApproved"
                  error={touched?.isApproved && errors?.isApproved}
                  label="KYC Approve"
                  selectValue={KYC_STATUS}
                  showSearch
                />
                <div className="checkBoxForm">
                  <label>Verified</label>
                  <Checkbox
                    onChange={() => setFieldValue('isVerified', !values?.isVerified)}
                    checked={values?.isVerified}
                  />
                </div>
                <div className="checkBoxForm">
                  <label>Active</label>
                  <Checkbox onChange={() => setFieldValue('isActive', !values?.isActive)} checked={values?.isActive} />
                </div>
                <div className="checkBoxForm">
                  <label>Natural</label>
                  <Checkbox onChange={() => setFieldValue('showNatural', !values?.showNatural)} checked={values?.showNatural} />
                </div>
                <div className="checkBoxForm">
                  <label>Lab-Grown</label>
                  <Checkbox onChange={() => setFieldValue('showLabGrown', !values?.showLabGrown)} checked={values?.showLabGrown} />
                </div>
                {/* <div className="checkBoxForm">
                  <label>KYC Approved?</label>
                  <Checkbox
                    onChange={() => setFieldValue('isApproved', !values?.isApproved)}
                    checked={values?.isApproved}
                  />
                </div> */}
              </div>
              <div className="d-flex j-space-between mb-20">
                <Heading className="smallTitle p-0" title="Contact Details" />
              </div>
              <div className="kycBlockWrapper mb-20 addRemoveinputBlock">
                <InputBlock
                  name="name"
                  label="Contact Person Name"
                  placeholder="Contact Person Name"
                  type="text"
                  value={values?.name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched?.name && errors?.name}
                />
                <InputBlock
                  name="contactEmail"
                  label="Email"
                  placeholder="Email"
                  type="text"
                  value={values?.contactEmail}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched?.contactEmail && errors?.contactEmail}
                />
                <InputBlock
                  name="Website"
                  label="Website"
                  placeholder="Website"
                  type="text"
                  value={values?.Website}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched?.Website && errors?.Website}
                />
                <InputBlock
                  name="contactMobile"
                  label="Mobile Number"
                  onKeyPress={(evt) => {
                    if (evt.which < 48 || evt.which > 57) {
                      evt.preventDefault();
                    }
                  }}
                  placeholder="Mobile Number"
                  type="text"
                  value={values?.contactMobile}
                  onChange={(event) => {
                    setFieldValue('contactMobile', event.target.value.replace(/\D/g, ''));
                  }}
                  onBlur={handleBlur}
                  error={touched?.contactMobile && errors?.contactMobile}
                />
                <InputBlock
                  name="faxes"
                  label="FAX Numbers"
                  placeholder="FAX Numbers"
                  type="text"
                  value={values?.faxes}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched?.faxes && errors?.faxes}
                />
              </div>
              {/* <div className="tabinnerTitle">Upload Document *</div>
              <FileUpload
                onChange={(value) => setFieldValue('vendorLogo', value)}
                onBlur={() => setFieldTouched('vendorLogo', true)}
                error={touched?.vendorLogo && errors?.vendorLogo}
                label="Choose Document"
                files={[values?.vendorLogo]}
              /> */}
            </div>
            <BottomStickyButton>
              <button
                className="commonButton"
                type="button"
                onClick={() => this.setState({ saveContinue: true }, submitForm)}
              >
                {isEmpty(this.props.account) ? 'Add Account & Continue' : `Save & Continue`}
              </button>
              {!isEmpty(this.props.account) && (
                <button
                  className="commonButton"
                  type="button"
                  onClick={() => this.setState({ saveContinue: false }, submitForm)}
                >
                  Save
                </button>
              )}
              <button className="commonOutine" type="reset" onClick={this.props.onCancel}>
                Cancel
              </button>
            </BottomStickyButton>
          </Form>
        )}
      </Formik>
    );
  }
}

export default ClientKYCDetail;
